import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './constants';
import Root from './components/Root';

ReactDOM.render(<Root />, document.getElementById('root'));

